import React from 'react';
import styled, { css } from 'styled-components';
import propTypes from 'prop-types';
import PlaceHolder from '../../../../../../UI/Editor/EditSpace/EditorPane/RenderContent/placeholder';
import placeholders from '../placeholders';
import { isSafari } from '../../../../../../../../../utility/browsers';
import breakpointsMinWidth from '../../../../../../../../../styling/breakpointsMinWidth';
import getWordSelectionDoubleClick from '../utils/getWordSelectionDoubleClick';

const returnOrganizationStyle = ({ isFocused }) => {
  if (isFocused) {
    return css`
      border: 1px solid rgba(133, 16, 223, 1);
      box-sizing: border-box;
      border-radius: 4px;
    `;
  }

  return null;
};

const OrganizationAddressWrapper = styled.div`
  user-select: ${(props) => props.isSafari && 'text !important'};
  -webkit-user-select: ${(props) => props.isSafari && 'text !important'};

  grid-column: 2/-1;
  border: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  padding: 0 10px;
  border-radius: 4px;
  position: relative;
  box-sizing: border-box;
  height: 40px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: #333d47;
  width: 100%;
  pointer-events: auto;
  cursor: text;
  ${(props) => returnOrganizationStyle(props)}

  @media ${breakpointsMinWidth.mobileMicroLg} {
    padding: 0 16px;
  }

  @media ${breakpointsMinWidth.tabletSm} {
    height: 36px;
    padding: 0 9px;
  }

  @media ${breakpointsMinWidth.desktopSm} {
    padding: 0 10px;
  }

  @media ${breakpointsMinWidth.desktopMd} {
    height: 40px;
    padding: 0 14px;
    font-size: 14px;
  }
`;

const PlaceHolder2 = styled(PlaceHolder)`
  position: absolute;
  font-weight: normal;
`;

const OrganizationAddress = ({ nodeProps }) => {
  const { node, attributes, children, isFocused, editor } = nodeProps;
  const {
    value: { focusBlock },
  } = editor;
  const nodeKey = node?.key;
  const path = editor?.value?.document?.getPath(nodeKey)?.toJS();

  return (
    <OrganizationAddressWrapper
      {...attributes}
      isFocused={isFocused}
      aria-label={node.type}
      onMouseDown={(e) => {
        if (e.detail === 2) {
          getWordSelectionDoubleClick({ editor });
        }
        if (e.detail >= 3) {
          e.preventDefault();
          e.stopPropagation();
          editor.moveToRangeOfNode(focusBlock);
        }
      }}
      isSafari={isSafari}
      data-testid={`${node.type}-${path?.join('-')}`}
    >
      <span className="single-line">
        <PlaceHolder2
          contentEditable={false}
          isFocused={isFocused}
          nodeText={node.text}
        >
          {placeholders[node.type]}
        </PlaceHolder2>
        {children}
      </span>
    </OrganizationAddressWrapper>
  );
};

OrganizationAddress.propTypes = {
  nodeProps: propTypes.objectOf(propTypes.object).isRequired,
  attributes: propTypes.objectOf(propTypes.string).isRequired,
};

export default OrganizationAddress;
